import { type CommunicationFormValues, type EmailTemplate } from "@repo/api";
import { type RefObject, useEffect } from "react";
import { type UseFormSetValue } from "react-hook-form";

import { DIRTY_AND_VALIDATE, loadTemplateContent } from "./utils";

interface Props {
  selectedTemplateKey?: string;
  selectedLanguage: string;
  defaultLanguage: string;
  enabledTemplates: EmailTemplate[];
  setValue: UseFormSetValue<CommunicationFormValues>;
  isDraftRestoredRef: RefObject<boolean>;
  isUserEditedRef: RefObject<boolean>;
}

export function useTemplateContent({
  selectedTemplateKey,
  selectedLanguage,
  defaultLanguage,
  enabledTemplates,
  setValue,
  isDraftRestoredRef,
  isUserEditedRef,
}: Props) {
  useEffect(() => {
    if (!selectedTemplateKey) {
      return;
    }

    if (isDraftRestoredRef.current) {
      isDraftRestoredRef.current = false;
      return;
    }

    if (isUserEditedRef.current) {
      return;
    }

    const template = enabledTemplates.find(
      (t) => t.template_name_key === selectedTemplateKey
    );
    if (!template) {
      return;
    }

    const { subject, body } = loadTemplateContent(
      template,
      selectedLanguage,
      selectedLanguage !== defaultLanguage ? defaultLanguage : undefined
    );

    setValue("subject", subject, DIRTY_AND_VALIDATE);
    setValue("body", body, DIRTY_AND_VALIDATE);
  }, [
    selectedTemplateKey,
    selectedLanguage,
    defaultLanguage,
    enabledTemplates,
    setValue,
    isDraftRestoredRef,
    isUserEditedRef,
  ]);
}
